import { makeStyles } from '@material-ui/core';

import { COLORS } from 'src/data/ui';

export default makeStyles(
  () => ({
    root: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: COLORS.gray.gray70,
    },
    image: {
      maxHeight: '100%',
      maxWidth: '100%',
    },
  }),
  { name: 'ImageFrame' }
);
